import React, { useEffect, useState } from "react";
import logo from "../../Assets/logo.svg";
import {
    Bed,
    BookOpenText,
    CallBell,
    CaretDown,
    CaretUp,
    ChartBar,
    ClockClockwise,
    PlusCircle,
    SignOut,
    User,
} from "@phosphor-icons/react";
import { Outlet, Link, useLocation } from "react-router-dom";
import Rooms from "./Rooms";
import Bookings from "./Bookings";
import Analytics from "./Analytics";
import Request from "./Request";
import { useNavigate } from "react-router-dom";
import CreateBooking from "./CreateBooking";
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slice/authSlice";
import axiosInstance from "../../api/axiosInstance";
import promotionsImg from "../../Assets/megaphone.png";
import promotionsImg2 from "../../Assets/megaphone (1).png";


const Dashboard = () => {
    const [activeComponent, setActiveComponent] = useState("request"); // Default to 'request'
    const navigate = useNavigate();
    const [openCreateBooking, setOpenCreateBooking] = useState(false);
    const location = useLocation();
    const [name, setName] = useState("");
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };
    // Function to handle which component to render
    const renderContent = () => {
        switch (activeComponent) {
            case "request":
                return <Request />;
            case "rooms":
                return <Rooms />;
            case "bookings":
                return <Bookings />;
            case "analytics":
                return <Analytics />;
            default:
                return <Request />;
        }
    };
    const dispatch = useDispatch();
    const hotelId = localStorage.getItem("hotelId");

    useEffect(() => {
        const fetchHotel = async () => {
            try {
                const response = await axiosInstance.get(
                    `/api/v1/hotels/${hotelId}`,
                );
                // console.log(response.data);
                setName(response.data?.name);
            } catch (error) {
                console.error(error);
            }
        };
        fetchHotel();
    }, [hotelId]);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/");
    };

    const isActive = (path) => location.pathname === path;
    return (
        <div className="h-screen">
            {/* Header */}
            <header className="w-full flex justify-between items-center px-4 sm:px-8 lg:px-4 bg-white border-b-[1.5px] z-10 fixed h-16">
                <div
                    className="flex items-center cursor-pointer"
                    // onClick={() => navigate("/")}
                >
                    <img
                        src={logo}
                        alt="logo"
                        className="h-8 w-8 mr-2 2xl:h-16 2xl:w-16"
                    />
                    <h1 className="text-2xl 2xl:text-42xl text-[#050F4E]">
                        Alfred
                    </h1>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        className="px-3 py-2 rounded-lg outline-none bg-[#ff7378] flex items-center gap-1"
                        onClick={() => setOpenCreateBooking(!openCreateBooking)}
                    >
                        <PlusCircle size={17} />
                        Create Booking
                    </button>
                    <button
                        onClick={toggleDropdown}
                        className="flex gap-1 items-center border-[1.5px] border-[#ff7378] rounded-md p-1.5 text-[#050f4e]"
                    >
                        <User />
                        {name}
                        {isDropdownOpen ? (
                            <CaretUp weight="fill" />
                        ) : (
                            <CaretDown weight="fill" />
                        )}
                    </button>

                    {/* Dropdown Menu */}
                    {isDropdownOpen && (
                        <div className="absolute top-full mt-2 right-4 bg-white border border-[#ff7378] rounded-lg shadow-lg p-2 flex flex-col z-10">
                            <button
                                className="px-4 py-2 hover:bg-[#ff7378] hover:text-white rounded-md flex items-center gap-2 text-[#050f4e]"
                                onClick={handleLogout}
                            >
                                <SignOut weight="fill" />
                                Logout
                            </button>
                            <button
                                className="px-4 py-2 mt-1 hover:bg-[#ff7378] hover:text-white rounded-md flex items-center gap-2 text-[#050f4e]"
                                onClick={() => navigate("/onboard", { state: { title: "editProfile" } })}
                            >
                                <ClockClockwise size={18} />
                                Edit Profile
                            </button>
                        </div>
                    )}
                </div>
            </header>

            {openCreateBooking && <CreateBooking func={setOpenCreateBooking} />}

            {/* Layout with Sidebar and Main Content */}
            <div className="flex pt-16">
                {/* Sidebar */}
                <div className="bg-[#FFBFC1] flex flex-col p-3 items-center fixed left-0 bg-opacity-60 h-full">
                    <Link to="/dashboard/request">
                        <button
                            className={`h-[32px] w-[32px] flex items-center justify-center mb-6 rounded-md ${
                                isActive("/dashboard/request")
                                    ? "bg-[#FF5A5F] text-white"
                                    : "text-[#737880]"
                            }`}
                            title="Requests"
                        >
                            <CallBell size={20} />
                        </button>
                    </Link>
                    <Link to="/dashboard/rooms">
                        <button
                            className={`h-[32px] w-[32px] flex items-center justify-center mb-6 rounded-md ${
                                isActive("/dashboard/rooms")
                                    ? "bg-[#FF5A5F] text-white"
                                    : "text-[#737880]"
                            }`}
                            title="Rooms"
                        >
                            <Bed size={20} />
                        </button>
                    </Link>
                    <Link to="/dashboard/bookings">
                        <button
                            className={`h-[32px] w-[32px] flex items-center justify-center mb-6 rounded-md ${
                                isActive("/dashboard/bookings")
                                    ? "bg-[#FF5A5F] text-white"
                                    : "text-[#737880]"
                            }`}
                            title="Bookings"
                        >
                            <BookOpenText size={20} />
                        </button>
                    </Link>

                    {/* Promotions */}
                    <Link to="/dashboard/promotions">
                        <button
                            className={`h-[32px] w-[32px] flex items-center justify-center mb-6 rounded-md  ${
                                isActive("/dashboard/promotions")
                                    ? "bg-[#FF5A5F] text-white"
                                    : "text-[#737880]"
                            }`}
                            title="Promotions"
                        >
                            {isActive("/dashboard/promotions") ?   <img src={promotionsImg2} alt="Promotions" className="h-[25px] w-[25px]"/> :  <img src={promotionsImg} alt="Promotions"className="h-[25px] w-[25px]"/>}
 
                        </button>
                    </Link>
 

                    <Link to="/dashboard/analytics">
                        <button
                            className={`h-[32px] w-[32px] flex items-center justify-center mb-6 rounded-md ${
                                isActive("/dashboard/analytics")
                                    ? "bg-[#FF5A5F] text-white"
                                    : "text-[#737880]"
                            }`}
                            title="Analytics"
                        >
                            <ChartBar size={20} />
                        </button>
                    </Link>
                </div>

                {/* Main Content Area */}
                <div className="ml-[55px] w-full p-4 bg-[#F2F7FF]">
                    <Outlet />{" "}
                    {/* Renders the component based on the nested route */}
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
